var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"plain logo",attrs:{"src":_vm.logoUrl,"alt":_vm.alt,"title":_vm.alt,"loading":"lazy"}})}
var staticRenderFns = []

export { render, staticRenderFns }